'use strict';

import template from 'employer/templates/governmentForms/Attachment.ejs';
import loader from 'helpers/loader';
import downloadjs from 'downloadjs';
import moment from 'moment';

module.exports = Backbone.View.extend({
    className: 'col-lg-6 col-md-6 col-sm-6',

    events: {
        'click .js-submit':  'submit',
        'click .js-destroy': 'destroyModel',
        'click .js-download': 'download'
    },

    initialize: function() {
        this.model.on('sync', this.render, this);
        this.model.on('destroy', this.remove, this);

        return this.render();
    },

    render: function() {
        const showDelete =
            moment(this.model.get('createdAt')).year() ===
            moment().year();
        this.$el.html(template({model: this.model, showDelete}));

        return this;
    },

    submit: function() {
        this.model.addTag('submitted');
    },

    destroyModel: function(ev) {
        var $button = this.$(ev.currentTarget);
        var stopLoader = loader.startFullScreen($button);

        this.model.destroy().finally(stopLoader);
    },

    download: function(ev) {
        ev.preventDefault();
        const that = this;

        /* jQuery ajax cannot be used here because messes up the response */
        const xhr = new XMLHttpRequest();
        xhr.open('GET', this.model.getUrl(), true);
        xhr.responseType = 'blob';
        xhr.onload = function() {
            // TODO: handle errors
            // Alternatively we could use the whatwg-fetch polyfill
            if (this.status == 200) {
                // get binary data as a response
                var blob = this.response;
                downloadjs(blob, that.model.get('name'), 'application/pdf');
            }
        };
        xhr.send();
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/governmentForms/Attachment.js